import { c } from 'ttag';

/**
 * The title of the screens on the way to disabling two-factor authentication: each way to prove the account is the
 * user's, and support when there's none.
 */
export const getDisableTwoFactorTitle = () => c('Title').t`Disable two-factor authentication?`;
